import { z } from 'zod';
import { JsonValueZod } from './json.value.zod';

export const EntityBoardContextSeedZod = z.object({
  header: z.object({
    title: z.string().optional(),
    showSearch: z.boolean().optional(),
    showPaginator: z.boolean().optional(),
    preFilters: z.record(z.string(), JsonValueZod).optional(),
  }).strict().optional(),
  defaultSort: z.array(z.object({ field: z.string(), direction: z.enum(['asc', 'desc']) }).strict()).optional(),
  defaultColumns: z.array(z.string()).optional(),
}).strict();

export const EntityDashboardContextSeedZod = z.object({
  title: z.string().optional(),
  preFilters: z.record(z.string(), JsonValueZod).optional(),
  defaultLayout: z.string().optional(),
}).strict();

export type EntityBoardContextSeed = z.infer<typeof EntityBoardContextSeedZod>;
export type EntityDashboardContextSeed = z.infer<typeof EntityDashboardContextSeedZod>;
